import { genericUnpackingLocalStorageProperties } from 'apps/web/constants/localStorage';
import { GenericUnpackingProperties } from 'apps/web/enums/pageKey';
import { getLocalStorageItem } from 'apps/web/utils/helper';

import FORM_KEYS from './formKeys';

const formDefaultValues = () => ({
  GenericUnpackingLP: {
    [FORM_KEYS.subject]: getLocalStorageItem(
      genericUnpackingLocalStorageProperties[
        GenericUnpackingProperties.subject
      ],
    ),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      genericUnpackingLocalStorageProperties[
        GenericUnpackingProperties.gradeLevel
      ],
    ),
    [FORM_KEYS.unpackType]: 'Learning Competency',
    [FORM_KEYS.itemToUnpack]: getLocalStorageItem(
      genericUnpackingLocalStorageProperties[
        GenericUnpackingProperties.itemToUnpack
      ],
    ),
  },
});

export default formDefaultValues;
